<div
    *ngIf="allowTransform; else defaultImage"
    class="img-container"
    [class.-sh-fullscreen]="fullscreen"
    (wheel)="scrollZoom($event)"
    (mousedown)="onDragStart($event)"
    (mouseup)="onDragEnd($event)"
    (mouseleave)="onDragEnd($event)"
    (mousemove)="onDragOver($event)"
>
    <img
        #image
        [class.sh-visually-hidden]="loading"
        [class.draggable]="draggable && !dragging"
        [class.dragging]="draggable && dragging"
        [class.transition]="transition"
        [class.-sh-fullscreen]="fullscreen"
        [src]="_imageSources[index]"
        [ngStyle]="style"
        draggable="false"
        alt="Image not accessible..."
        (load)="onLoad(_imageSources[index])"
        (error)="imageNotFound(_imageSources[index])"
        (loadstart)="onLoadStart(_imageSources[index])"
    />
    <div class="spinner-container" *ngIf="loading">
        <svg sh-icon class="-sh-spin" [name]="'spinner'" aria-hidden="true"></svg>
    </div>

    <div class="nav-button-container" *ngIf="_imageSources.length > 1">
        <button type="button" class="sh-pure-icon-button -sh-raised" [title]="viewerTranslations.previous" (click)="prevImage($event)" [disabled]="index === 0">
            <svg sh-icon [name]="'arrow-left'" aria-hidden="true"></svg>
        </button>
        <button
            type="button"
            class="sh-pure-icon-button -sh-raised"
            [title]="viewerTranslations.next"
            (click)="nextImage($event)"
            [disabled]="index === _imageSources.length - 1"
        >
            <svg sh-icon [name]="'arrow-right'" aria-hidden="true"></svg>
        </button>
    </div>
</div>

<div *ngIf="allowTransform && actionsPosition !== ViewerActionsPosition.BOTTOM_EXTERNAL" class="viewer-action-container--vertical">
    <ng-container *ngFor="let item of imageActionButtons">
        <button type="button" class="sh-pure-icon-button -sh-raised" [ngClass]="actionsPosition" [title]="item.label" (click)="item.eventListener()">
            <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
        </button>
    </ng-container>
</div>

<div *ngIf="allowTransform && actionsPosition === ViewerActionsPosition.BOTTOM_EXTERNAL" class="viewer-action-container">
    <ng-container *ngFor="let item of imageActionButtons">
        <button type="button" class="sh-pure-icon-button -sh-raised" [ngClass]="actionsPosition" [title]="item.label" (click)="item.eventListener()">
            <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
        </button>
    </ng-container>
</div>

<ng-template #defaultImage>
    <div class="img-container">
        <img
            #image
            [class.sh-visually-hidden]="loading"
            [class.-sh-fullscreen]="fullscreen"
            [src]="_imageSources[index]"
            [ngStyle]="style"
            draggable="false"
            alt="Image not accessible..."
            (load)="onLoad(_imageSources[index])"
            (error)="imageNotFound(_imageSources[index])"
            (loadstart)="onLoadStart(_imageSources[index])"
        />
    </div>
</ng-template>
